import apiService from '@services/base/apiService';
import { env } from '@configuration/env';
import { GebruikerApiApi, TussenpersonenApiApi } from './api';

const baseUrl = env.VUE_APP_MANAGEMENT_BASE_URL;

export const gebruikerApi = apiService.create(GebruikerApiApi, baseUrl);
export const adviseurApi = apiService.create(TussenpersonenApiApi, baseUrl);
